const STATUS = {
  disputed: 'DISPUTED',
  certified: 'CERTIFIED',
  canceled: 'CANCELLED',
}

function getFilter(filter) {
  const filters = {
    own: (questions, userData) => getOwnQuestions(questions, userData),
    disputed: (questions) => getDisputedQuestions(questions),
    resolved: (questions) => getResolvedQuestions(questions),
    search: (questions, userData, search) => getSearchedQuestions(questions, userData, search),
  }

  return filters[filter]
}

export function getVotes(debate) {
  let votes = {
    positive: 0,
    negative: 0,
  }
  debate.filter((d) => d.vote).map((d) => (votes[d.vote] += 1))

  return votes
}
function getOwnQuestions(questions, userData) {
  return questions.filter((question) => {
    return question.createdBy == userData.id
  })
}

export function getTotalCorrectAnswers(answers) {
  return answers ? answers.filter((answer) => answer.right).length : []
}

function getResolvedQuestions(questions) {
  return questions.filter(
    (question) => question.status == STATUS.certified || question.status == STATUS.canceled
  )
}

function getDisputedQuestions(questions) {
  return questions.filter((question) => question.status == STATUS.disputed)
}

function getSearchedQuestions(questions, userdata, search) {
  if (!search) return questions

  return questions.filter((q) => {
    return q.question.toLowerCase().includes(search.toLowerCase())
  })
}

function findVote(debate, user) {
  let voted = false
  const userDebate = debate.find((d) => d.authorLicenseId == user)
  if (userDebate && userDebate.vote) {
    voted = user.vote == 'positive' ? 'valid' : 'invalid'
  }
  return voted
}

function checkVote(question, ownQuestion, disputed, voted) {
  if (!voted) {
    return { ...question, state: 'not' }
  }
  if (
    (question.status == STATUS.certified && (ownQuestion || voted == 'valid')) ||
    (question.status == STATUS.canceled && (disputed || voted == 'invalid'))
  ) {
    return { ...question, state: 'won' }
  }
  return { ...question, state: 'lost' }
}

function checkDisputableQuestions(questions, userId) {
  return questions.map((question) => {
    const ownQuestion = question.createdBy == userId
    const disputed = question.dispute.disputerLicenseId == userId
    const voted = findVote(question.dispute.debate, userId)

    if (question.status == STATUS.disputed) {
      if (!ownQuestion && !disputed && !voted) {
        return { ...question, state: 'toDispute' }
      }
      return { ...question, state: 'disputed' }
    }
    return checkVote(question, ownQuestion, disputed, voted)
  })
}

export function getFilteredQuestions(questions, filter, userdata, search) {
  if (!filter) return checkDisputableQuestions(questions, userdata.id)

  const filterQuestions = getFilter(filter)
  const filteredQuestions = filterQuestions(questions, userdata, search)

  return checkDisputableQuestions(filteredQuestions, userdata.id)
}
